import { createApp } from 'vue'
import App from './App.vue'
import './index.css';  // This imports Tailwind's styles

createApp(App).mount('#app')
